/* Boonsoir 2.0 — recipe page: portions that rescale quantities, ingredient ticks, steps you tap off,
   a screen wake lock while you make it, and print. No dependencies; everything works without this file too. */
(() => {
  'use strict';
  if (window.BoonsoirRecipe) return;

  const QTY = /^(\d+(?:[.,]\d+)?)(\s*(?:ml|cl|dl|l|g|gr|gram|kg|el|tl|eetlepels?|theelepels?|stuks?|st|blaadjes?|takjes?|schijfjes?|scheutjes?|druppels?|snufjes?|shots?)?)(\b|\s|$)/i;
  const PLURAL = { glas: 'glazen', kop: 'koppen', kopje: 'kopjes', persoon: 'personen', portie: 'porties', mok: 'mokken', beker: 'bekers', fles: 'flessen', kan: 'kannen' };
  const fmt = (n) => {
    const r = Math.round(n * 100) / 100;
    return String(Number.isInteger(r) ? r : r.toFixed(r * 10 % 1 === 0 ? 1 : 2)).replace('.', ',');
  };

  class Recipe {
    constructor(root) {
      this.root = root;
      this.base = Math.max(1, parseInt(root.dataset.portions, 10) || 1);
      this.unit = (root.dataset.portionsUnit || 'glas').toLowerCase();
      this.count = this.base;
      this.ings = [...root.querySelectorAll('[data-rcp-ing]')].map((el) => this.prepare(el)).filter(Boolean);
      this.portions = root.querySelector('[data-rcp-portions]');
      this.out = root.querySelector('[data-rcp-count]');
      if (this.portions && this.ings.length) {
        this.portions.hidden = false;
        this.portions.addEventListener('click', (e) => {
          const b = e.target.closest('[data-rcp-step]');
          if (!b) return;
          this.set(this.count + parseInt(b.dataset.rcpStep, 10));
        });
        this.render();
      }
      root.addEventListener('click', (e) => {
        const step = e.target.closest('[data-rcp-done]');
        if (step) { step.setAttribute('aria-pressed', step.getAttribute('aria-pressed') !== 'true'); return; }
        const print = e.target.closest('[data-rcp-print]');
        if (print) window.print();
      });
      const print = root.querySelector('[data-rcp-print]');
      if (print && typeof window.print === 'function') print.hidden = false;
      this.wake = root.querySelector('[data-rcp-wake]');
      if (this.wake && 'wakeLock' in navigator && matchMedia('(pointer: coarse)').matches) {
        this.wake.hidden = false;
        this.wake.addEventListener('click', () => this.toggleWake());
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && this.wanted) this.requestWake(); });
      }
    }

    /* Wrap the leading quantity so it can be rescaled; keep the original text for the base portion. */
    prepare(el) {
      const text = el.textContent.trim();
      const m = QTY.exec(text);
      if (!m) return null;
      const num = parseFloat(m[1].replace(',', '.'));
      if (!num) return null;
      const rest = text.slice(m[1].length);
      el.textContent = '';
      const q = document.createElement('span');
      q.className = 'rcp__qty';
      q.textContent = m[1];
      el.append(q, rest);
      return { q, num };
    }

    set(n) {
      this.count = Math.min(12, Math.max(1, n));
      this.render();
    }

    render() {
      const f = this.count / this.base;
      this.ings.forEach(({ q, num }) => { q.textContent = fmt(num * f); });
      if (this.out) {
        const unit = this.count === 1 ? this.unit : PLURAL[this.unit] || this.unit;
        this.out.textContent = `${this.count} ${unit}`;
      }
      this.portions.querySelector('[data-rcp-step="-1"]').disabled = this.count <= 1;
      this.portions.querySelector('[data-rcp-step="1"]').disabled = this.count >= 12;
    }

    async toggleWake() {
      if (this.lock) { this.wanted = false; await this.lock.release().catch(() => {}); this.lock = null; this.wake.setAttribute('aria-pressed', 'false'); return; }
      this.wanted = true;
      this.requestWake();
    }

    async requestWake() {
      try {
        this.lock = await navigator.wakeLock.request('screen');
        this.wake.setAttribute('aria-pressed', 'true');
        this.lock.addEventListener('release', () => { this.lock = null; this.wake.setAttribute('aria-pressed', 'false'); });
      } catch (err) {
        this.wake.setAttribute('aria-pressed', 'false');
        this.wanted = false;
      }
    }

    destroy() {
      if (this.lock) this.lock.release().catch(() => {});
    }
  }

  const live = new Map();
  const init = (scope = document) => scope.querySelectorAll('[data-recipe]').forEach((el) => { if (!live.has(el)) live.set(el, new Recipe(el)); });
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => { e.target.querySelectorAll('[data-recipe]').forEach((el) => { const r = live.get(el); if (r) { r.destroy(); live.delete(el); } }); });
  window.BoonsoirRecipe = { init };
})();
